"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Keycloak
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTokenCommandToJSON = exports.GetTokenCommandFromJSONTyped = exports.GetTokenCommandFromJSON = void 0;
function GetTokenCommandFromJSON(json) {
    return GetTokenCommandFromJSONTyped(json, false);
}
exports.GetTokenCommandFromJSON = GetTokenCommandFromJSON;
function GetTokenCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'grantType': json['grant_type'],
        'clientId': json['client_id'],
        'clientSecret': json['client_secret'],
        'identificationRequest': json['identification_request'],
    };
}
exports.GetTokenCommandFromJSONTyped = GetTokenCommandFromJSONTyped;
function GetTokenCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'grant_type': value.grantType,
        'client_id': value.clientId,
        'client_secret': value.clientSecret,
        'identification_request': value.identificationRequest,
    };
}
exports.GetTokenCommandToJSON = GetTokenCommandToJSON;
//# sourceMappingURL=GetTokenCommand.js.map